/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Temperature_Warning_ComfortInputs */



/**
* | output |
* | --- |
* | "The room temperature should be around the comfort temperature." |
*
* @param {Calibration_Temperature_Warning_ComfortInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_warning_comfort = /** @type {((inputs?: Calibration_Temperature_Warning_ComfortInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_Warning_ComfortInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The room temperature should be around the comfort temperature.")
	return /** @type {LocalizedString} */ ("La température de la pièce doit se trouver autour de la température de confort")
});